import Bowser from 'bowser';
import UnsupportedBrowserPage from '../../../pages/errors/UnsupportedBrowser';

const BrowserCheck = ({ children }) => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    const isSupported = browser.satisfies({
        chrome: '>=79',
        edge: '>=79',
        firefox: '>=68',
        safari: '>=12',
    });
    if (!isSupported) {
        return <UnsupportedBrowserPage />;
    }

    const isIE = !!document.documentMode;
    const hasModernAPIs = typeof Promise !== 'undefined' && typeof fetch !== 'undefined' && typeof Symbol !== 'undefined' && typeof Array.prototype.includes !== 'undefined' && typeof Object.assign === 'function';

    const isModernBrowser = !isIE && hasModernAPIs;
    if (!isModernBrowser) {
        return <UnsupportedBrowserPage />;
    }

    return children;
};

export default BrowserCheck;
